import { render, staticRenderFns } from "./SkimovieProblems.vue?vue&type=template&id=24fd0536&"
import script from "./SkimovieProblems.vue?vue&type=script&lang=js&"
export * from "./SkimovieProblems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports